interface Segment { value: number; color: string; label: string; }
interface Props   { segments: Segment[]; size?: number; stroke?: number; }

export default function DonutChart({ segments, size=110, stroke=18 }: Props) {
  const r    = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const total = segments.reduce((s, seg) => s + seg.value, 0);
  let offset = 0;

  return (
    <svg width={size} height={size} style={{ transform:"rotate(-90deg)" }}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="#f1f5f9" strokeWidth={stroke}/>
      {segments.map((seg, i) => {
        const len = total === 0 ? 0 : (seg.value / total) * circ;
        const el = (
          <circle key={i} cx={size/2} cy={size/2} r={r} fill="none"
            stroke={seg.color} strokeWidth={stroke}
            strokeDasharray={`${len} ${circ - len}`}
            strokeDashoffset={-offset}/>
        );
        offset += len;
        return el;
      })}
    </svg>
  );
}
